import { gql } from '@apollo/client';
import React from 'react';
import { VariantCell, VARIANT_CELL_FRAGMENT } from '../VariantCell';
import { LookCell, LOOK_CELL_FRAGMENT } from '../LookCell';
import { TrunkshowCell, TRUNKSHOW_CELL_FRAGMENT } from '../TrunkshowCell';
import { CarouselCellFragment } from '../../../../generated/types/CarouselCellFragment';
import { EditorialCell, EDITORIAL_CELL_FRAGMENT } from '../EditorialCell';

export const CAROUSEL_CELL_FRAGMENT = gql`
  fragment CarouselCellFragment on CarouselCell {
    __typename
    ... on Variant {
      ...VariantCellFragment
    }
    ... on Look {
      ...LookCellFragment
    }
    ... on Trunkshow {
      ...TrunkshowCellFragment
    }
    ... on Slide {
      ...EditorialCellFragment
    }
  }
  ${VARIANT_CELL_FRAGMENT}
  ${LOOK_CELL_FRAGMENT}
  ${TRUNKSHOW_CELL_FRAGMENT}
  ${EDITORIAL_CELL_FRAGMENT}
`;

interface Props {
  carouselCell: CarouselCellFragment;
}

export const CarouselCell: React.FC<Props> = ({ carouselCell }) => {
  switch (carouselCell.__typename) {
    case 'Variant':
      return <VariantCell variant={carouselCell} />;
    case 'Trunkshow':
      return <TrunkshowCell trunkshow={carouselCell} />;
    case 'Look':
      return <LookCell look={carouselCell} />;
    case 'Slide':
      return <EditorialCell editorial={carouselCell} />;
    default:
      return null;
  }
};
